/**
 * CUSTOM (16/9): sticky add-to-cart bar on the product page (mobile).
 * Appears once the real add-to-cart button is scrolled out of view and
 * simply triggers that button, so variant selection, sold-out state and the
 * cart drawer keep working exactly as the theme does it.
 */
(function () {
  const main = document.getElementById('MainContent');
  if (!main || main.dataset.template !== 'product') return;

  const getMainBtn = () => main.querySelector('.buy-buttons-block .add-to-cart-button');
  const mainBtn = getMainBtn();
  if (!mainBtn) return;

  const bar = document.createElement('div');
  bar.className = 'sticky-atc';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML =
    '<button type="button" class="button sticky-atc__button"><span class="sticky-atc__label"></span></button>';
  document.body.appendChild(bar);

  const btn = bar.querySelector('.sticky-atc__button');
  const label = bar.querySelector('.sticky-atc__label');

  /** copy text + disabled state from the real button (updates after variant changes) */
  const sync = () => {
    const src = getMainBtn();
    if (!src) return;
    const text = (src.querySelector('.add-to-cart-text') || src).textContent.replace(/\s+/g, ' ').trim();
    if (text && label.textContent !== text) label.textContent = text;
    btn.disabled = src.disabled;
  };
  sync();
  new MutationObserver(sync).observe(main, {
    subtree: true,
    childList: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['disabled'],
  });

  btn.addEventListener('click', () => {
    const src = getMainBtn();
    if (src && !src.disabled) src.click();
  });

  // show the bar when the real button is above the viewport
  const setVisible = (above) => {
    bar.classList.toggle('is-visible', above);
    bar.setAttribute('aria-hidden', above ? 'false' : 'true');
  };
  const check = () => {
    const src = getMainBtn();
    if (!src) return setVisible(false);
    setVisible(src.getBoundingClientRect().bottom < 0);
  };

  let observed = null;
  const io =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries) => {
            const e = entries[entries.length - 1];
            setVisible(!e.isIntersecting && e.boundingClientRect.top < 0);
          },
          { threshold: 0 }
        )
      : null;
  const watch = () => {
    const src = getMainBtn();
    if (io && src && src !== observed) {
      if (observed) io.unobserve(observed);
      observed = src;
      io.observe(src);
    }
  };
  watch();
  // the theme morphs the product form after a variant change: re-attach if the button was replaced
  new MutationObserver(watch).observe(main, { subtree: true, childList: true });

  // scroll fallback (rAF-throttled)
  let ticking = false;
  window.addEventListener(
    'scroll',
    () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        ticking = false;
        check();
      });
    },
    { passive: true }
  );
  check();
})();
